import { Fragment, useState } from 'react';

import Slider from 'react-slick';

import map from 'lodash/fp/map';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import useResponsiveVariant from 'utils/useResponsiveVariant';

import type { Product } from '../types';
import { ProductCard } from './ProductCard';

type ProductsMobileSliderProps = {
  fetchedProducts: Product[];
};

const StyledSlider = styled(Slider)<{ slideNumber: number }>`
  width: 100%;

  .slick-dots {
    position: initial;

    display: flex !important;
    flex: 1;
    align-items: center;

    height: 50px;
    padding: 0 12px;
    li {
      width: 100%;
      margin: 0;
    }
    li:first-of-type > div {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    li:last-of-type > div {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }
  .slick-track .slick-slide:last-child {
    padding-right: 12px;
  }
`;

const SliderCardsContainer = styled('div')`
  padding: 0 0px 0 12px;
  ${legacyTheme.breakpoints.up('sm')} {
    padding: 0 0px 0 18px;
  }
  ${legacyTheme.breakpoints.up('lg')} {
    padding: 0 0 0 0;
  }
`;

const Dot = styled('div')<{ currentSlide: number; index: number }>`
  width: 100%;
  height: 5px;
  background: ${theme.colors.primary[300]};
  opacity: ${(props) => (props.currentSlide === props.index ? '1' : '0.15')};
`;

export const ProductsMobileSlider = ({ fetchedProducts }: ProductsMobileSliderProps) => {
  const { isMobile } = useResponsiveVariant();
  const [currentSlide, setCurrentSlide] = useState(0);
  const cards = map((product: Product) => {
    return (
      <Fragment key={product.label}>
        <SliderCardsContainer>
          <ProductCard
            dataClick={`${product.slug}-card`}
            dataFrom="haircare-grid"
            product={product}
          />
        </SliderCardsContainer>
      </Fragment>
    );
  }, fetchedProducts);

  const customPaging = (i: number) => <Dot currentSlide={currentSlide} index={i} />;
  const slidesToShowValue = isMobile ? 1.5 : 2.5;

  return (
    <StyledSlider
      // The slide value can be a float because of a weird trick we need to do to display only one percentage of a card in the slider
      afterChange={(slide: number) => setCurrentSlide(Math.round(slide))}
      arrows={false}
      customPaging={customPaging}
      dots
      focusOnSelect
      infinite={false}
      slideNumber={cards.length - 1}
      slidesToShow={slidesToShowValue}
    >
      {cards}
    </StyledSlider>
  );
};
